export default class Settings
{
  constructor(email, phone, facebook, instagram, address, latitude, longitude) 
  {
    this.email = email;
    this.phone = phone;
    this.facebook = facebook;
    this.instagram = instagram;
    this.address = address;
    this.latitude = latitude;
    this.longitude = longitude;
  }    

  isValid()
  {
    return this.email && this.email.toString().trim() &&
           this.phone && this.phone.toString().trim() &&
           this.facebook && this.facebook.toString().trim() &&
           this.instagram && this.instagram.toString().trim() &&
           this.address && this.address.toString().trim() &&
           this.latitude && this.latitude.toString().trim() &&
           this.longitude && this.longitude.toString().trim();
  }
}